<template>
  <v-layout md-12>
    <v-flex md-3 lg-3>
      <v-list-item two-line class="border-right">
        <v-list-item-avatar>
          <v-icon class="blue white--text">mdi-currency-usd</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <div class="overline">Tổng Số</div>
          <v-list-item-title class="headline blue--text nowrap">{{total | formatMoney}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-flex>
    <v-flex md-3 lg-3>
      <v-list-item two-line class="border-right">
        <v-list-item-avatar>
          <v-icon class="red white--text">mdi-check</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-subtitle>Công Nợ</v-list-item-subtitle>
          <v-list-item-title class="red--text nowrap">{{liabilities | formatMoney}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-flex>
    <v-flex md-3 lg-3>
      <v-list-item two-line>
        <v-list-item-avatar>
          <v-icon class="orange white--text font-weight-black">mdi-sale</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-subtitle>Giảm Giá</v-list-item-subtitle>
          <v-list-item-subtitle>
            <h1 class="subtitle-1 orange--text nowrap">{{discount | formatMoney}}</h1>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-flex>
  </v-layout>
</template>

<script>
import utils from '@/plugins/utils.js'
export default {
  props: {
    leads: Array
  },
  computed: {
    sum () {
      return (
        [...this.leads].reduce((sum, lead) => {
          return sum + lead.sum
        }, 0) || 0
      )
    },
    total () {
      return (
        [...this.leads].reduce((total, lead) => {
          return total + lead.customerPaid
        }, 0) || 0
      )
    },
    liabilities () {
      return (
        this.leads.reduce((liabilities, lead) => {
          return liabilities + lead.liabilities
        }, 0) || 0
      )
    },
    discount () {
      return (
        this.leads.reduce((discount, lead) => {
          return discount + lead.discount
        }, 0) || 0
      )
    }
  },
  filters: {
    formatMoney (data) {
      return utils.formatMoney(data)
    }
  }
}
</script>

<style scoped>
.border-right {
  border-right: solid 1px gray;
}
.v-list-item {
  padding-left: 0;
}
.nowrap {
  white-space: nowrap;
}
</style>
